// frontend/src/services/recurrenceService.js
import api from './apiService';

/**
 * Busca a lista de todas as regras de recorrência do usuário.
 */
export const getRecurrences = async () => {
    const response = await api.get('/financeiro/recorrencias/');
    return response.data;
};

/**
 * Busca a agenda de uma recorrência: próximas ocorrências projetadas e
 * histórico recente (pagas, puladas ou alteradas).
 */
export const getRecurrenceAgenda = async (id) => {
    const response = await api.get(`/financeiro/recorrencias/${id}/agenda/`);
    return response.data;
};

/**
 * Cria uma nova regra de recorrência.
 */
export const createRecurrence = async (recurrenceData) => {
    const response = await api.post('/financeiro/recorrencias/', recurrenceData);
    return response.data;
};

/**
 * Atualiza uma regra de recorrência existente.
 */
export const updateRecurrence = async (id, recurrenceData) => {
    const response = await api.put(`/financeiro/recorrencias/${id}/`, recurrenceData);
    return response.data;
};

/**
 * Exclui uma regra de recorrência permanentemente.
 */
export const deleteRecurrence = async (id) => {
    await api.delete(`/financeiro/recorrencias/${id}/`);
};

/**
 * Cria uma exceção para uma recorrência (pular ou modificar uma ocorrência).
 */
export const createRecorrenciaExcecao = async (excecaoData) => {
    const response = await api.post('/financeiro/recorrencias-excecoes/', excecaoData);
    return response.data;
};

// ===================================================================================
// INÍCIO DA CORREÇÃO
// ===================================================================================
/**
 * Confirma uma ocorrência de recorrência, criando uma transação real e a exceção correspondente.
 */
export const confirmarOcorrenciaRecorrencia = async (id, dadosConfirmacao) => {
    const response = await api.post(`/financeiro/recorrencias/${id}/confirmar-ocorrencia/`, dadosConfirmacao);
    return response.data;
};
// ===================================================================================
// FIM DA CORREÇÃO
// ===================================================================================

/**
 * Raio-X de assinaturas: total mensal já classificado como assinatura, a lista delas e as
 * recorrências ainda pendentes de classificação (assinatura vs. conta fixa).
 */
export const getRaioXAssinaturas = async () => {
    const response = await api.get('/financeiro/recorrencias/raio-x-assinaturas/');
    return response.data;
};

/**
 * Classifica (ou reclassifica) manualmente a natureza de gasto de uma recorrência
 * ('ASSINATURA' | 'CONTA_FIXA' | null). A escolha é lembrada para recorrências futuras
 * de descrição parecida.
 */
export const definirNaturezaRecorrencia = async (id, naturezaGasto) => {
    const response = await api.patch(`/financeiro/recorrencias/${id}/`, { natureza_gasto: naturezaGasto });
    return response.data;
};
